import React, { Fragment } from 'react'

//componets
import ThemeMenuThree from '../../../components/header/ThemeMenuThree'
import PageTitle from '../../../components/page-title/PageTitle'
import ProjectMasonryGrid from '../../../components/project/ProjectMasonryGrid'
import NewsletterTwo from '../../../components/call-to-action/NewsletterTwo'
import FooterThree from '../../../components/footer/FooterThree'
import { Link } from 'react-router-dom'

const ProjectMasonry = () => {
    return (
        <Fragment>
            <div className="main-page-wrapper">
                {/* Helmet start */}
                {/* Helmet end */}

                {/* ThemeMenuThree */}
                <ThemeMenuThree />
                {/* ThemeMenuThree */}

                {/* PageTitle */}
                <PageTitle title="구축 사례" parentTo="/" parentLabel="홈" />
                {/* PageTitle */}

                {/*feature-work start*/}
                <section className="codam-project-masonry pt-145 pb-105 pt-lg-55 pb-lg-15">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center justify-content-center">
                            <div className="col-xl-6 col-lg-6 col-md-8">
                                <div className="section-title text-center mb-25">
                                    <h6 className="sub-title mb-20">주요 프로젝트</h6>
                                    <h3 className="sect-title mb-25" data-aos="fade-up">
                                        대표 구축 사례를 살펴보세요
                                    </h3>
                                    <p data-aos="fade-up">
                                        카드형 메이슨리 레이아웃으로 사례를 모았습니다. 상단 탭에서 분야별로 필터링할 수
                                        있습니다.
                                    </p>
                                </div>
                            </div>
                        </div>
                        {/* ProjectMasonryGrid start */}
                        <ProjectMasonryGrid />
                        {/* ProjectMasonryGrid end */}
                        <div className="row">
                            <div className="col-lg-12 text-center mt-10 mb-45">
                                <Link className="theme_btn" to="/project-grid">
                                    그리드 레이아웃으로 보기
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
                {/*feature-work end*/}

                {/*codam-newsletter start*/}
                <NewsletterTwo />
                {/*codam-newsletter end*/}

                {/* FooterThree start */}
                <FooterThree />
                {/* FooterThree end */}
            </div>
        </Fragment>
    )
}

export default ProjectMasonry
